module.exports = __webpack_public_path__ + "static/img/sku.6d87cbca.png";